export function initGalleryReels() {
    const reels = document.querySelectorAll('.dcGalleryReels');
    if (!reels.length) return;

    reels.forEach(reel => {
        const items = Array.from(reel.querySelectorAll('.dcGalleryReelsItem'));
        if (!items.length) return;
        reel.innerHTML = '';

        const row = document.createElement('div');
        row.className = 'dcGalleryReels__row';

        const track = document.createElement('div');
        track.className = 'dcGalleryReels__track';

        items.forEach(item => track.appendChild(item));
        row.appendChild(track);
        reel.appendChild(row);

        const loadVideos = () => {
            track.querySelectorAll('video[data-src]').forEach(video => {
                video.src = video.getAttribute('data-src');
                video.removeAttribute('data-src');
            });
        };

        const originalItems = Array.from(track.children);
        const originalWidth = track.scrollWidth;
        const targetWidth = (reel.offsetWidth || window.innerWidth) * 3;

        let iterations = 0;
        while (track.scrollWidth < targetWidth && iterations < 20) {
            originalItems.forEach(item => {
                const clone = item.cloneNode(true);
                clone.setAttribute('data-clone', 'true');
                // s. galleryCarousel.js: Klone sind Marquee-Fuellung, sie
                // gehoeren nicht in die Tab-Reihenfolge (42 Vorkommen).
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('tabindex', '-1');
                clone.addEventListener('click', (e) => {
                    e.preventDefault();
                    const index = clone.getAttribute('data-index');
                    const original = track.querySelector(`.js-openGallery[data-index="${index}"]:not([data-clone])`);
                    if (original) original.click();
                });
                track.appendChild(clone);
            });
            iterations++;
        }

        const scrollSpeed = 0.2;
        const elTopAbsolute = reel.getBoundingClientRect().top + window.scrollY;
        const initialRel = Math.max(0, window.innerHeight - elTopAbsolute);

        const onScroll = () => {
            const rel = Math.max(0, window.scrollY + window.innerHeight - elTopAbsolute) - initialRel;
            let offset = -(rel * scrollSpeed) % originalWidth;
            if (offset > 0) offset -= originalWidth;
            track.style.transform = `translateX(${offset}px)`;
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                loadVideos();
                window.addEventListener('scroll', onScroll, { passive: true });
                observer.disconnect();
            });
        }, { rootMargin: '200px' });

        observer.observe(reel);

        reel.classList.add('is-initialized');
    });
}